import { defineTarget } from "./types.ts";
import type { TargetProfile } from "./types.ts";

const FORMATS = new Set([
  "date-time",
  "time",
  "date",
  "duration",
  "email",
  "hostname",
  "ipv4",
  "ipv6",
  "uuid",
]);

export const openaiResponsesStructured: TargetProfile = defineTarget({
  id: "openai/responses/structured",
  aliases: [
    "openai",
    "openai/structured",
    "openai/strict",
    "openai/chat/structured",
    "openai/responses/tools",
  ],
  vendor: "openai",
  mode: "structured",
  revision: "2026-08",
  maturity: "supported",
  dialect: "2020-12",
  evidence: "documented",
  evidenceSource: "https://developers.openai.com/api/docs/guides/structured-outputs",
  lastVerified: "2026-08-18",
  liveAdapter: true,
  capabilities: {
    anyOf: "supported",
    oneOf: "lossy",
    allOf: "unsupported",
    not: "unsupported",
    refs: "supported",
    recursiveRefs: "supported",
    defs: "supported",
    nullableTypeArray: "supported",
    optionalProperties: "lossy",
    additionalPropertiesTrue: "unsupported",
    additionalPropertiesSchema: "unsupported",
    pattern: "supported",
    format: "supported",
    minLength: "runtime-only",
    maxLength: "runtime-only",
    minimum: "supported",
    maximum: "supported",
    exclusiveMinimum: "supported",
    exclusiveMaximum: "supported",
    multipleOf: "supported",
    minItems: "supported",
    maxItems: "supported",
    uniqueItems: "runtime-only",
    prefixItems: "unsupported",
    minProperties: "runtime-only",
    maxProperties: "runtime-only",
    enum: "supported",
    const: "supported",
    integer: "supported",
    nullType: "supported",
  },
  formats: FORMATS,
  limits: {
    maxDepth: 10,
    maxProperties: 5000,
    maxEnumValues: 1000,
    maxStringBudget: 120_000,
  },
  objectPolicy: {
    additionalProperties: false,
    requireAllProperties: true,
    optionalAsNullable: true,
  },
  rootMustBeObject: true,
  rootAnyOf: "unsupported",
});
